import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';

import { CourseReserveStatusComponent } from '®shared/course-reserve-status/course-reserve-status.component';
import { FieldedItemModule } from '®shared/list-item/fielded';

import { ListItemPlaceholderComponent } from './list-item-placeholder.component';

@NgModule({
  imports: [CommonModule, FieldedItemModule],
  declarations: [ListItemPlaceholderComponent, CourseReserveStatusComponent],
  exports: [ListItemPlaceholderComponent, CourseReserveStatusComponent],
})
export class ContainerStructureCommonModule {}
